import { getDashUrl } from '../utils/config';
import { getFetch } from '../utils/fetch';

export const getTimeOnTaskByCourseAndUser = async (courseId, userId) => {
  try {
    const getTimeOnTaskByCourseAndUserUrl = `${getDashUrl()}/api/v1/dashboards/courses/${courseId}/users/${userId}/timeontask`;
    const response = await fetch(getTimeOnTaskByCourseAndUserUrl, {
      method: 'GET',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) {
      throw new Error(
        `Server request to get time on task data failed.  ${response.status} ${response.statusText}`,
      );
    }
    const timeOnTaskData = response.json();
    return timeOnTaskData;
  } catch (_error) {
    return [];
  }
};

export const getStudentGoalReflection = async (courseId, studentId, goal) => {
  const response = await getFetch(
    `${getDashUrl()}/api/v1/dashboards/courses/${courseId}/students/${studentId}/goal-reflections/${goal}`,
  );
  if (!response.ok) {
    throw new Error(
      `Server request to get student goal reflection data failed.  ${response.status} ${response.statusText}`,
    );
  }
  return response.json();
};
